import React from 'react';
import { useTranslation } from 'react-i18next';
import { toSnake } from 'src/utils/core/word';
import { toSimpleDateString } from 'src/utils/format/date';
import s from './tableColumns.styles';

export const MasterDataManagerColumns = () => {
  const { t } = useTranslation();

  const renderDateCell = item => {
    const link = `/master-data/${toSnake(item.entityType, '-')}`;
    return (
      <s.TableCellComponent>
        <s.Link to={link} withoutDelete>
          <s.Item>{toSimpleDateString(item.createdAt)}</s.Item>
        </s.Link>
      </s.TableCellComponent>
    );
  };
  const renderCell = item => {
    const link = `/master-data/${toSnake(item.entityType, '-')}`;
    return (
      <s.TableCellComponent>
        <s.Link to={link} withoutDelete>
          <s.Item>{item.userName}</s.Item>
        </s.Link>
      </s.TableCellComponent>
    );
  };
  const renderEntityCell = item => {
    const entityLink = `/master-data/${toSnake(item.entityType, '-')}/${
      item.entityId
    }`;
    const link = `/master-data/${toSnake(item.entityType, '-')}`;
    const entityType = toSnake(item.entityType).toUpperCase();
    return (
      <s.TableCellComponent>
        <s.Link to={entityLink} withoutDelete>
          <s.Item>
            {t(entityType)} /{' '}
            <s.EntityName to={entityLink}>{item.entityName}</s.EntityName>
          </s.Item>
        </s.Link>
      </s.TableCellComponent>
    );
  };

  const columns = [
    {
      Header: t('COLUMN_DATE_AND_TIME'),
      id: 'created_at',
      accessor: 'createdAt',
      Cell: ({ row }) => renderDateCell(row.original),
      show: true,
    },
    {
      Header: t('COLUMN_MD_TABLE_ITEM'),
      id: 'entity_type',
      accessor: 'entityType',
      Cell: ({ row }) => renderEntityCell(row.original),
      show: true,
      /* sortType: (a, b, fieldName) => compareData(a.original, b.original, fieldName) */
    },
    {
      Header: t('COLUMN_EDITED_BY'),
      id: 'user_id',
      accessor: 'userName',
      Cell: ({ row }) => renderCell(row.original),
      show: true,
      /* sortType: (a, b, fieldName) => compareData(a.original, b.original, fieldName) */
    },
  ];

  return columns;
};
